import type { DirectiveBinding } from 'vue'

export default {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    // Always use Tailwind's bg-clip-text and text-transparent for shimmer
    el.classList.add('bg-clip-text', 'text-transparent')

    // Detect theme
    // Prefer class-based dark mode detection (Tailwind's 'dark' class or custom 'darkMode')
    const root = document.documentElement
    const isDarkMode = root.classList.contains('dark') || root.classList.contains('dark')
    const isLightMode = !isDarkMode

    // High-contrast for light, subtle for dark
    const background = binding.value?.background || (isLightMode ? '#6b7280' : '#737373') // slate-200 for light, slate-800 for dark
    const shineColor = binding.value?.shineColor || (isLightMode ? '#f97316' : '#e86104')
    const duration = binding.value?.duration || '3s'
    const timingFunction = binding.value?.timingFunction || 'linear'

    // Set shimmer background and animation
    el.style.backgroundImage = `linear-gradient(75deg, ${background} 0%, ${shineColor} 80%, ${background} 100%, ${shineColor} 5%)`
    el.style.backgroundSize = '200% 100%'
    el.style.animation = `shimmer ${duration} ${timingFunction} infinite`

    // Inject keyframes only once
    if (!document.getElementById('text-shimmer-keyframes')) {
      const style = document.createElement('style')
      style.id = 'text-shimmer-keyframes'
      style.textContent = `
        @keyframes shimmer {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
      `
      document.head.appendChild(style)
    }
  },
  unmounted(el: HTMLElement) {
    el.classList.remove('bg-clip-text', 'text-transparent')
    el.style.backgroundImage = ''
    el.style.backgroundSize = ''
    el.style.animation = ''
  },
}
